module.exports = __webpack_public_path__ + "img/facebook.e50a1a87.svg";